import React, { useEffect, useRef } from 'react'
import anime from 'animejs'

export class Arrow extends React.Component {

	render() {
		const arrowDirection = this.props.direction ? this.props.direction : ''
		const arrowTheme = this.props.theme ? this.props.theme : ''
		const arrowClasses = `ui-arrow direction-${arrowDirection} ui-theme-${arrowTheme}`
		return (
			<div className={ arrowClasses }>
				<svg id="ui-arrow" xmlns="http://www.w3.org/2000/svg" width="221.5" height="80" viewBox="0 0 221.5 80">
					<g id="cyan">
						<g id="Path_12" transform="translate(141.5)" fill="none">
							<path d="M40,0A40,40,0,1,1,0,40,40,40,0,0,1,40,0Z" stroke="none"/>
							<path d="M 40 1 C 34.73458862304688 1 29.62722396850586 2.031013488769531 24.81974411010742 4.064399719238281 C 20.17577743530273 6.028633117675781 16.00485610961914 8.8408203125 12.42283630371094 12.42283630371094 C 8.8408203125 16.00485610961914 6.028633117675781 20.17577743530273 4.064399719238281 24.81974411010742 C 2.031013488769531 29.62722396850586 1 34.73458862304688 1 40 C 1 45.26541137695312 2.031013488769531 50.37277984619141 4.064399719238281 55.18025588989258 C 6.028633117675781 59.82422256469727 8.8408203125 63.99514389038086 12.42283630371094 67.57716369628906 C 16.00485610961914 71.1591796875 20.17577743530273 73.97136688232422 24.81974411010742 75.93560028076172 C 29.62722396850586 77.96898651123047 34.73458862304688 79 40 79 C 45.26541137695312 79 50.37277984619141 77.96898651123047 55.18025588989258 75.93560028076172 C 59.82422256469727 73.97136688232422 63.99514389038086 71.1591796875 67.57716369628906 67.57716369628906 C 71.1591796875 63.99514389038086 73.97136688232422 59.82422256469727 75.93560028076172 55.18025588989258 C 77.96898651123047 50.37277984619141 79 45.26541137695312 79 40 C 79 34.73458862304688 77.96898651123047 29.62722396850586 75.93560028076172 24.81974411010742 C 73.97136688232422 20.17577743530273 71.1591796875 16.00485610961914 67.57716369628906 12.42283630371094 C 63.99514389038086 8.8408203125 59.82422256469727 6.028633117675781 55.18025588989258 4.064399719238281 C 50.37277984619141 2.031013488769531 45.26541137695312 1 40 1 M 40 0 C 62.09138870239258 0 80 17.90861129760742 80 40 C 80 62.09138870239258 62.09138870239258 80 40 80 C 17.90861129760742 80 0 62.09138870239258 0 40 C 0 17.90861129760742 17.90861129760742 0 40 0 Z" stroke="none" fill="aqua"/>
						</g>
						<path id="Path_11" d="M4.955,0,9.911,8.259H0Z" transform="translate(187.129 35.155) rotate(90)" fill="aqua"/>
						<path id="Path_10" d="M180,0H0" transform="translate(0 40.5)" fill="none" stroke="aqua" strokeWidth="1"/>
					</g>
					<g id="red">
						<g id="Path_12-2" transform="translate(141.5)" fill="none">
							<path d="M40,0A40,40,0,1,1,0,40,40,40,0,0,1,40,0Z" stroke="none"/>
							<path d="M 40 1 C 34.73458862304688 1 29.62722396850586 2.031013488769531 24.81974411010742 4.064399719238281 C 20.17577743530273 6.028633117675781 16.00485610961914 8.8408203125 12.42283630371094 12.42283630371094 C 8.8408203125 16.00485610961914 6.028633117675781 20.17577743530273 4.064399719238281 24.81974411010742 C 2.031013488769531 29.62722396850586 1 34.73458862304688 1 40 C 1 45.26541137695312 2.031013488769531 50.37277984619141 4.064399719238281 55.18025588989258 C 6.028633117675781 59.82422256469727 8.8408203125 63.99514389038086 12.42283630371094 67.57716369628906 C 16.00485610961914 71.1591796875 20.17577743530273 73.97136688232422 24.81974411010742 75.93560028076172 C 29.62722396850586 77.96898651123047 34.73458862304688 79 40 79 C 45.26541137695312 79 50.37277984619141 77.96898651123047 55.18025588989258 75.93560028076172 C 59.82422256469727 73.97136688232422 63.99514389038086 71.1591796875 67.57716369628906 67.57716369628906 C 71.1591796875 63.99514389038086 73.97136688232422 59.82422256469727 75.93560028076172 55.18025588989258 C 77.96898651123047 50.37277984619141 79 45.26541137695312 79 40 C 79 34.73458862304688 77.96898651123047 29.62722396850586 75.93560028076172 24.81974411010742 C 73.97136688232422 20.17577743530273 71.1591796875 16.00485610961914 67.57716369628906 12.42283630371094 C 63.99514389038086 8.8408203125 59.82422256469727 6.028633117675781 55.18025588989258 4.064399719238281 C 50.37277984619141 2.031013488769531 45.26541137695312 1 40 1 M 40 0 C 62.09138870239258 0 80 17.90861129760742 80 40 C 80 62.09138870239258 62.09138870239258 80 40 80 C 17.90861129760742 80 0 62.09138870239258 0 40 C 0 17.90861129760742 17.90861129760742 0 40 0 Z" stroke="none" fill="red"/>
						</g>
						<path id="Path_11-2" d="M4.955,0,9.911,8.259H0Z" transform="translate(187.129 35.155) rotate(90)" fill="red"/>
						<path id="Path_10-2" d="M180,0H0" transform="translate(0 40.5)" fill="none" stroke="red" strokeWidth="1"/>
					</g>
					<g id="dark">
						<g id="Path_12-3" transform="translate(141.5)" fill="none">
							<path d="M40,0A40,40,0,1,1,0,40,40,40,0,0,1,40,0Z" stroke="none"/>
							<path d="M 40 1 C 34.73458862304688 1 29.62722396850586 2.031013488769531 24.81974411010742 4.064399719238281 C 20.17577743530273 6.028633117675781 16.00485610961914 8.8408203125 12.42283630371094 12.42283630371094 C 8.8408203125 16.00485610961914 6.028633117675781 20.17577743530273 4.064399719238281 24.81974411010742 C 2.031013488769531 29.62722396850586 1 34.73458862304688 1 40 C 1 45.26541137695312 2.031013488769531 50.37277984619141 4.064399719238281 55.18025588989258 C 6.028633117675781 59.82422256469727 8.8408203125 63.99514389038086 12.42283630371094 67.57716369628906 C 16.00485610961914 71.1591796875 20.17577743530273 73.97136688232422 24.81974411010742 75.93560028076172 C 29.62722396850586 77.96898651123047 34.73458862304688 79 40 79 C 45.26541137695312 79 50.37277984619141 77.96898651123047 55.18025588989258 75.93560028076172 C 59.82422256469727 73.97136688232422 63.99514389038086 71.1591796875 67.57716369628906 67.57716369628906 C 71.1591796875 63.99514389038086 73.97136688232422 59.82422256469727 75.93560028076172 55.18025588989258 C 77.96898651123047 50.37277984619141 79 45.26541137695312 79 40 C 79 34.73458862304688 77.96898651123047 29.62722396850586 75.93560028076172 24.81974411010742 C 73.97136688232422 20.17577743530273 71.1591796875 16.00485610961914 67.57716369628906 12.42283630371094 C 63.99514389038086 8.8408203125 59.82422256469727 6.028633117675781 55.18025588989258 4.064399719238281 C 50.37277984619141 2.031013488769531 45.26541137695312 1 40 1 M 40 0 C 62.09138870239258 0 80 17.90861129760742 80 40 C 80 62.09138870239258 62.09138870239258 80 40 80 C 17.90861129760742 80 0 62.09138870239258 0 40 C 0 17.90861129760742 17.90861129760742 0 40 0 Z" stroke="none" fill="currentColor"/>
						</g>
						<path id="Path_11-3" d="M4.955,0,9.911,8.259H0Z" transform="translate(187.129 35.156) rotate(90)" fill="currentColor"/>
						<path id="Path_10-3" d="M180,0H0" transform="translate(0 40.5)" fill="none" stroke="currentColor" strokeWidth="1"/>
					</g>
				</svg>
			</div>
		)
	}
}

Arrow.defaultProps = {
	direction: 'right',
	theme: 'dark',
}

export class WatchButton extends React.Component {
	render() {
		const watchTheme = this.props.theme ? this.props.theme : ''
		const watchClasses = `ui-watch ui-theme-${watchTheme}`

		return (
			<div className='watchButtonContainer'>
				<button onClick={this.props.onClick} className={ watchClasses }>
					<svg xmlns="http://www.w3.org/2000/svg" width="80" height="80" viewBox="0 0 80 80">
						<g id="watch_btn" transform="translate(-257 -419)">
							<g id="cyan">
								<g id="Ellipse_22" transform="translate(257 419)" fill="none" stroke="aqua" strokeWidth="1">
									<circle cx="40" cy="40" r="40" stroke="none"/>
									<circle cx="40" cy="40" r="39.5" fill="none"/>
								</g>
								<path id="Path_62" d="M4.955,0,9.911,8.259H0Z" transform="translate(302.629 454.156) rotate(90)" fill="aqua"/>
							</g>
							<g id="red">
								<g id="Ellipse_22-2" transform="translate(257 419)" fill="none" stroke="red" strokeWidth="1">
									<circle cx="40" cy="40" r="40" stroke="none"/>
									<circle cx="40" cy="40" r="39.5" fill="none"/>
								</g>
								<path id="Path_62-2" d="M4.955,0,9.911,8.259H0Z" transform="translate(302.629 454.156) rotate(90)" fill="red"/>
							</g>
							<g id="default">
								<g id="Ellipse_22-3" transform="translate(257 419)" fill="none" stroke="currentColor" strokeWidth="1">
									<circle cx="40" cy="40" r="40" stroke="none"/>
									<circle cx="40" cy="40" r="39.5" fill="none"/>
								</g>
								<path id="Path_62-3" d="M4.955,0,9.911,8.259H0Z" transform="translate(302.629 454.156) rotate(90)" fill="currentColor"/>
							</g>
						</g>
					</svg>
					<span>WATCH</span>
				</button>
			</div>
		)
	}
}

export class PauseButton extends React.Component {
	render() {
		const pauseClasses = `ui-pause`

		return (
			<div className={pauseClasses}>
				{ !this.props.statusPause
				? <svg xmlns="http://www.w3.org/2000/svg" width="80" height="80" viewBox="0 0 80 80">
					<g id="ui-pause" data-name="Group 59" transform="translate(-257 -419)">
						<g id="cyan">
							<g id="Ellipse_22" transform="translate(257 419)" fill="none" stroke="aqua" strokeWidth="1">
								<circle cx="40" cy="40" r="40" stroke="none"/>
								<circle cx="40" cy="40" r="39.5" fill="none"/>
							</g>
							<path id="Path_11" d="M1246.5,2576v-10h3v10Zm-5,0v-10h3v10Z" transform="translate(-948.5 -2112)" fill="aqua"/>
						</g>
						<g id="red">
							<g id="Ellipse_22-2" transform="translate(257 419)" fill="none" stroke="red" strokeWidth="1">
								<circle cx="40" cy="40" r="40" stroke="none"/>
								<circle cx="40" cy="40" r="39.5" fill="none"/>
							</g>
							<path id="Path_11-2" d="M1246.5,2576v-10h3v10Zm-5,0v-10h3v10Z" transform="translate(-948.5 -2112)" fill="red"/>
						</g>
						<g id="default">
							<g id="Ellipse_22-3" transform="translate(257 419)" fill="none" stroke="currentColor" strokeWidth="1">
								<circle cx="40" cy="40" r="40" stroke="none"/>
								<circle cx="40" cy="40" r="39.5" fill="none"/>
							</g>
							<path id="Path_11-3" d="M1246.5,2576v-10h3v10Zm-5,0v-10h3v10Z" transform="translate(-948.5 -2112)" fill="currentColor"/>
						</g>
					</g>
				</svg>
				: <svg xmlns="http://www.w3.org/2000/svg" width="80" height="80" viewBox="0 0 80 80">
					<g id="ui-pause" transform="translate(-257 -419)">
						<g id="cyan">
							<g id="Ellipse_22" transform="translate(257 419)" fill="none" stroke="aqua" strokeWidth="1">
								<circle cx="40" cy="40" r="40" stroke="none"/>
								<circle cx="40" cy="40" r="39.5" fill="none"/>
							</g>
							<path id="Path_62" d="M4.955,0,9.911,8.259H0Z" transform="translate(302.629 454.156) rotate(90)" fill="aqua"/>
						</g>
						<g id="red">
							<g id="Ellipse_22-2" transform="translate(257 419)" fill="none" stroke="red" strokeWidth="1">
								<circle cx="40" cy="40" r="40" stroke="none"/>
								<circle cx="40" cy="40" r="39.5" fill="none"/>
							</g>
							<path id="Path_62-2" d="M4.955,0,9.911,8.259H0Z" transform="translate(302.629 454.156) rotate(90)" fill="red"/>
						</g>
						<g id="default">
							<g id="Ellipse_22-3" transform="translate(257 419)" fill="none" stroke="currentColor" strokeWidth="1">
								<circle cx="40" cy="40" r="40" stroke="none"/>
								<circle cx="40" cy="40" r="39.5" fill="none"/>
							</g>
							<path id="Path_62-3" d="M4.955,0,9.911,8.259H0Z" transform="translate(302.629 454.156) rotate(90)" fill="currentColor"/>
						</g>
					</g>
				</svg>
				}
			</div>
		)
	}
}

export const Spinner = (props) => {
	const boxesRef = useRef()
	const textRef = useRef()

	useEffect(() => {
		return loadingAnime(boxesRef.current.childNodes, textRef.current.childNodes)
	}, []);

	return (
		<div className='spinner'>
			<svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48">
				<g id="loading_grid" transform="translate(-809 -701)" ref={boxesRef}>
					<rect id="loading_box-1" width="8" height="8" transform="translate(809 701)" fill="#404040" />
					<rect id="loading_box-2" width="8" height="8" transform="translate(819 701)" fill="#404040" />
					<rect id="loading_box-3" width="8" height="8" transform="translate(829 701)" fill="#404040" />
					<rect id="loading_box-4" width="8" height="8" transform="translate(839 701)" fill="#404040" />
					<rect id="loading_box-5" width="8" height="8" transform="translate(849 701)" fill="#404040" />
					<rect id="loading_box-6" width="8" height="8" transform="translate(809 711)" fill="#404040" />
					<rect id="loading_box-7" width="8" height="8" transform="translate(819 711)" fill="#404040" />
					<rect id="loading_box-8" width="8" height="8" transform="translate(829 711)" fill="#404040" />
					<rect id="loading_box-9" width="8" height="8" transform="translate(839 711)" fill="#404040" />
					<rect id="loading_box-10" width="8" height="8" transform="translate(849 711)" fill="#404040" />
					<rect id="loading_box-11" width="8" height="8" transform="translate(809 721)" fill="#404040" />
					<rect id="loading_box-12" width="8" height="8" transform="translate(819 721)" fill="#404040" />
					<rect id="loading_box-13" width="8" height="8" transform="translate(829 721)" fill="#404040" />
					<rect id="loading_box-14" width="8" height="8" transform="translate(839 721)" fill="#404040" />
					<rect id="loading_box-15" width="8" height="8" transform="translate(849 721)" fill="#404040" />
					<rect id="loading_box-16" width="8" height="8" transform="translate(809 731)" fill="#404040" />
					<rect id="loading_box-17" width="8" height="8" transform="translate(819 731)" fill="#404040" />
					<rect id="loading_box-18" width="8" height="8" transform="translate(829 731)" fill="#404040" />
					<rect id="loading_box-19" width="8" height="8" transform="translate(839 731)" fill="#404040" />
					<rect id="loading_box-20" width="8" height="8" transform="translate(849 731)" fill="#404040" />
					<rect id="loading_box-21" width="8" height="8" transform="translate(809 741)" fill="#404040" />
					<rect id="loading_box-22" width="8" height="8" transform="translate(819 741)" fill="#404040" />
					<rect id="loading_box-23" width="8" height="8" transform="translate(829 741)" fill="#404040" />
					<rect id="loading_box-24" width="8" height="8" transform="translate(839 741)" fill="#404040" />
					<rect id="loading_box-25" width="8" height="8" transform="translate(849 741)" fill="#404040" />
				</g>
			</svg>
			<div className="loading-text" ref={textRef}>
				<span>L</span>
				<span>O</span>
				<span>A</span>
				<span>D</span>
				<span>I</span>
				<span>N</span>
				<span>G</span>
			</div>
		</div>
	)
}

function loadingAnime( boxes, text ) {
	anime.timeline({
    autoplay: true,
    loop: true,
    direction: "alternate"
  })
  .add({
    targets: boxes,
    duration: 1000,
    delay: anime.stagger(200, { grid: [5, 5], from: "center" }),
    easing: "easeInOutQuad",
    opacity: [0.1, 0.9]
  })
  .add(
    {
      targets: text,
      duration: 1000,
      delay: anime.stagger(200, { grid: [1, 7], from: "center" }),
      easing: "easeInOutQuad",
      opacity: [0.9, 0.1]
    },
    0
  );
}